import * as React from 'react';
import { Button, Checkbox, Col, ControlLabel, FormControl, FormGroup, Row } from 'react-bootstrap';
import FormSelect from '../../../../components/common/FormSelect';
import ValidatableFormGroup from '../../../../components/common/ValidatableFormGroup';
import FormValidationService from '../../../../shared/form/FormValidationService';
import { Translate } from '../../../../shared/LanguageService';
import * as utils from '../../Utils/PhotographerFormUtils';
import { getSiteName } from '../../../../shared/Site';
import * as Site from '../../../../shared/Site';

const PhotographerFormComponentExtraInfo = (props: any) => {
    function checkBookable(propertyName: string) {
        let value = false;
        if (!props.user.isDiscontinued) {
            /* A discontinued photographer shouldn't be bookable */
            value = props.user && props.user[propertyName] ? props.user[propertyName] : false;
        }
        if (props.user && props.user[propertyName]) {
            props.user[propertyName] = value;
        }
        return value;
    }

    let isUserCountryFinland = (props) => {
        let isUserCountryFinland = false;
        isUserCountryFinland =
            (props.loggedInUser.impersonatedCountry && props.loggedInUser.impersonatedCountry.id === 2) 
            || props.loggedInUser.details.country === 2 ? true : false;
        return isUserCountryFinland;
    }

    return (
        <>
            <fieldset>
                <legend>{Translate('photographers/modal/form/legend/info')}</legend>
                <Row>
                    <Col md={6}>
                        <ValidatableFormGroup
                            required={
                                props.user.isBookableScandphotos === true ||
                                props.user.isBookableSe360 === true
                            }
                            validationKey="agreementId"
                            errors={props.errors}
                        >
                            <ControlLabel>
                                {Translate('photographers/modal/form/select-label/agreement')}
                            </ControlLabel>
                            <FormSelect
                                name="agreementId"
                                value={
                                    props.user && props.user.agreementId
                                        ? props.user.agreementId.toString()
                                        : ''
                                }
                                error={props.errors ? props.errors.agreementId : ''}
                                onChange={props.onChange}
                                defaultTranslateKey="photographers/modal/form/select-label/default/choose-agreement"
                            >
                                {props.agreements.map((a: any) => {
                                    return (
                                        <option value={a.value} key={a.value}>
                                            {a.label}
                                        </option>
                                    );
                                })}
                            </FormSelect>
                        </ValidatableFormGroup>
                        <ValidatableFormGroup
                            validationKey="imageEditorFirmId"
                            errors={props.errors}
                        >
                            <ControlLabel>
                                {Translate(
                                    'photographers/modal/form/select-label/image-editor-firm'
                                )}
                            </ControlLabel>
                            <FormSelect
                                name="imageEditorFirmId"
                                // 0 is a valid value meaning photographer edits imaged him/herself
                                value={
                                    props.user &&
                                    (props.user.imageEditorFirmId ||
                                        props.user.imageEditorFirmId === 0)
                                        ? props.user.imageEditorFirmId.toString()
                                        : ''
                                }
                                error={props.errors ? props.errors.imageEditorFirmId : ''}
                                onChange={props.onChange}
                                defaultTranslateKey="photographers/modal/form/select-label/default/choose-image-editor-firm"
                            >
                                {props.imageEditorFirms.map((i: any) => {
                                    return (
                                        <option value={i.value} key={i.value}>
                                            {i.label}
                                        </option>
                                    );
                                })}
                            </FormSelect>
                        </ValidatableFormGroup>
                        <FormGroup
                            controlId="photographerNumJobs"
                            validationState={FormValidationService.getValidationState(
                                props.errors.maxNumberOfJobs
                            )}
                        >
                            <ControlLabel>
                                {Translate(
                                    'photographers/modal/form/select-label/max-number-of-jobs'
                                )}
                            </ControlLabel>
                            <FormSelect
                                name="maxNumberOfJobs"
                                value={
                                    props.user && props.user.maxNumberOfJobs
                                        ? props.user.maxNumberOfJobs.toString()
                                        : ''
                                }
                                onChange={props.onChange}
                                defaultTranslateKey="photographers/modal/form/select-label/default/choose-max-number-of-jobs"
                            >
                                <option value="1">1</option>
                                <option value="2">2</option>
                                <option value="3">3</option>
                                <option value="4">4</option>
                                <option value="5">5</option>
                                <option value="6">6</option>
                                <option value="7">7</option>
                                <option value="8">8</option>
                                <option value="9">9</option>
                                <option value="10">10</option>
                            </FormSelect>
                        </FormGroup>
                    </Col>
                    {!isUserCountryFinland(props) ? (
                        <Col md={6}>
                            <ValidatableFormGroup
                                required={
                                    props.user.isBookableScandphotos === true ||
                                    props.user.isBookableSe360 === true
                                }
                                validationKey="bGNr"
                                errors={props.errors}
                            >
                                <ControlLabel>
                                    {Translate('photographers/modal/form/input-label/bg-nr')}
                                </ControlLabel>
                                <FormControl
                                    type="text"
                                    name="bgNr"
                                    value={props.user && props.user.bgNr ? props.user.bgNr : ''}
                                    onChange={props.onChange}
                                />
                            </ValidatableFormGroup>
                        </Col>
                    ) : null
                    }
                    <Col md={6}>
                        <FormGroup controlId="photographerComment">
                            <ControlLabel>
                                {Translate('photographers/modal/form/input-label/comment')}
                            </ControlLabel>
                            <FormControl
                                componentClass="textarea"
                                name="comment"
                                value={props.user && props.user.comment ? props.user.comment : ''}
                                onChange={props.onChange}
                            />
                        </FormGroup>
                    </Col>
                </Row>
                <Row>
                    <Col md={6}>
                        <FormGroup controlId="photographerStatus">
                            <div>
                                <ControlLabel>
                                    {Translate('photographers/modal/form/checkbox-section/status')}
                                </ControlLabel>
                            </div>
                            <Checkbox
                                name="isDiscontinued"
                                checked={
                                    props.user && props.user.isDiscontinued
                                        ? props.user.isDiscontinued
                                        : false
                                }
                                onChange={props.onCheckboxChange}
                            >
                                <span>
                                    {Translate(
                                        'photographers/modal/form/checkbox-label/is-discontinued'
                                    )}
                                </span>
                            </Checkbox>
                            <Checkbox
                                name="employedBySe360"
                                checked={
                                    props.user && props.user.employedBySe360
                                        ? props.user.employedBySe360
                                        : false
                                }
                                onChange={props.onCheckboxChange}
                            >
                                <span>
                                    {Translate(
                                        'photographers/modal/form/checkbox-label/is-employed-by-se360'
                                    )}
                                </span>
                            </Checkbox>
                        </FormGroup>
                    </Col>
                    <Col md={6}>
                        <FormGroup controlId="photographerBookable">
                            <div>
                                <ControlLabel>
                                    {Translate(
                                        'photographers/modal/form/checkbox-section/bookable'
                                    )}
                                </ControlLabel>
                            </div>
                            <Checkbox
                                disabled={props.user.isDiscontinued === true}
                                name="isBookableSe360"
                                checked={checkBookable('isBookableSe360')}
                                onChange={props.onCheckboxChange}
                            >
                                <span>
                                    {Translate(
                                        'photographers/modal/form/checkbox-label/bookable-se360'
                                    )}
                                </span>
                            </Checkbox>
                            {props.site !== getSiteName(Site.Zentuvo) ? <Checkbox
                                disabled={props.user.isDiscontinued === true}
                                name="isBookableScandphotos"
                                checked={checkBookable('isBookableScandphotos')}
                                onChange={props.onCheckboxChange}
                            >
                                <span>
                                    {Translate(
                                        'photographers/modal/form/checkbox-label/bookable-scandphotos'
                                    )}
                                </span>
                            </Checkbox> : null }
                        </FormGroup>
                    </Col>
                </Row>
            </fieldset>
            {cubicasaInfo(props)}
        </>
    );
};

const cubicasaInfo = (props: any) => {
    return (
        <fieldset>
            <legend>{Translate('photographers/modal/form/legend/cubicasa')}</legend>
            <Row>
                <Col md={props.user.profileImageReference ? 8 : 12}>
                    {!props.user.cubiCasaConnected ? (
                        <div>
                            <Button
                                disabled={utils.cubiCasaButonShouldBeDisabled(props.user)}
                                onClick={() => props.createCubiCasaConnection(props.user.id)}
                            >
                                {Translate('photographers/modal/form/button/connect-to-cubicasa')}
                            </Button>
                        </div>
                    ) : null}

                    {props.user.cubiCasaConnected ? (
                        <div>
                            <b>{Translate('photographers/modal/form/label/cubicasa/id')}: </b>{' '}
                            {props.user.cubiCasaId} <br />
                            <b>
                                {Translate('photographers/modal/form/label/cubicasa/role')}:{' '}
                            </b>{' '}
                            {Translate(props.user.cubiCasaRole.displayName)} <br />
                            <b>
                                {Translate('photographers/modal/form/label/cubicasa/status')}:{' '}
                            </b>{' '}
                            {Translate(props.user.cubiCasaStatus.displayName)}
                        </div>
                    ) : null}
                </Col>
            </Row>
        </fieldset>
    );
};

export default PhotographerFormComponentExtraInfo;
